module.exports = __webpack_public_path__ + "eae93111e90cd8a18987f637ba8fd292.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/ginseng.jpg
 ** module id = 450
 ** module chunks = 0
 **/